class CountdownBar extends HTMLElement {
  connectedCallback() {
    this.endTime = this.parseEnd(this.dataset.end);
    this.expiredText = this.dataset.expiredText || '';
    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.secondsEl = this.querySelector('[data-countdown-seconds]');
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  parseEnd(raw) {
    if (!raw) return null;
    // Accept "YYYY-MM-DD HH:MM:SS" or ISO string. Treat as local time when no TZ.
    const iso = raw.includes('T') ? raw : raw.replace(' ', 'T');
    const t = Date.parse(iso);
    return Number.isNaN(t) ? null : t;
  }

  tick() {
    if (!this.endTime) {
      this.renderExpired();
      clearInterval(this.timer);
      return;
    }
    const diff = this.endTime - Date.now();
    if (diff <= 0) {
      this.renderExpired();
      clearInterval(this.timer);
      return;
    }
    const s = Math.floor(diff / 1000);
    const days = Math.floor(s / 86400);
    const hours = Math.floor((s % 86400) / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;
    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  renderExpired() {
    if (this.expiredText) {
      this.textContent = this.expiredText;
    } else {
      ['daysEl', 'hoursEl', 'minutesEl', 'secondsEl'].forEach((k) => {
        if (this[k]) this[k].textContent = '00';
      });
    }
  }
}

if (!customElements.get('countdown-bar')) {
  customElements.define('countdown-bar', CountdownBar);
}
